import apiHandler from "../core/apiHandler";

/**
 * 📄 API base para PDF
 * de Corte X
 *
 * Endpoint:
 * /api/pdf/cash/x
 */
const cashXPdfApi =
    apiHandler("pdf/cash/x");

export default cashXPdfApi;